import { CategoryResult, CompetitionResult } from "../interfaces/ICompetitions";

export const isCompetitionVisibleInResults = (
  competition: CompetitionResult | null | undefined,
): boolean => competition?.displaySettings?.showCompetitionInResultsApp !== false;

export const hasVisibleFinalResults = (category: CategoryResult): boolean => {
  const scopes = category.finalResults?.publicationScopes || {
    category: category.publicationScopes?.categoryFinal,
    competition: category.publicationScopes?.competitionFinal,
  };

  if (!category.finalResults) {
    return scopes.category === true || scopes.competition === true;
  }

  return !scopes || scopes.category === true || scopes.competition === true;
};

export const hasHiddenRoundsBecauseOfFinals = (
  competition: CompetitionResult,
  category: CategoryResult,
): boolean =>
  competition.displaySettings?.hideRoundResultsWhenFinalResultsPublished === true &&
  (category.finalResults?.publicationScopes?.competition === true ||
    category.publicationScopes?.competitionFinal === true);

export const hasVisibleRoundResults = (
  competition: CompetitionResult,
  category: CategoryResult,
): boolean => {
  if (!isCompetitionVisibleInResults(competition)) {
    return false;
  }

  if ((category.publicationScopes?.hasPublishedRounds !== true && (category.rounds || []).length === 0) || !competition) {
    return false;
  }

  return !hasHiddenRoundsBecauseOfFinals(competition, category);
};
